import React, { useEffect, useState } from 'react';
import Button from 'antd/lib/button';
import Modal from 'antd/lib/modal';
import Select from 'antd/lib/select';

import { t } from 'utils/i18n';
import { fetchLibraries, LibraryOption } from './steps-api';

interface Props {
    libraries: string[];
    // what no chosen library means for this step
    fallback: string;
    busy: boolean;
    taskId?: number;
    onChange(libraries: string[]): void;
}

// the libraries Find furniture in library searches, and the dialog that changes them for the task
export default function LibraryLine({
    libraries, fallback, busy, taskId, onChange,
}: Props): JSX.Element {
    const [options, setOptions] = useState<LibraryOption[]>([]);
    const [draft, setDraft] = useState<string[] | null>(null);
    useEffect(() => {
        let cancelled = false;
        fetchLibraries(taskId).then((list) => { if (!cancelled) setOptions(list); }).catch(() => {});
        return () => { cancelled = true; };
    }, [taskId]);
    const name = (value: string): string => options.find((option) => option.value === value)?.key ?? value;
    return (
        <div className='cvat-step-libraries'>
            <span>{t('Libraries: {list}', { list: libraries.length ? libraries.map(name).join(', ') : fallback })}</span>
            <Button type='link' size='small' disabled={busy} onClick={() => setDraft(libraries)}>{t('Change')}</Button>
            {draft !== null && (
                <Modal
                    visible
                    title={t('Libraries for this task')}
                    okText={t('Save')}
                    onOk={() => { onChange(draft); setDraft(null); }}
                    onCancel={() => setDraft(null)}
                >
                    <Select
                        mode='multiple'
                        virtual={false}
                        className='cvat-step-libraries-select'
                        aria-label={t('Libraries')}
                        placeholder={fallback}
                        value={draft}
                        onChange={(value: string[]) => setDraft(value)}
                    >
                        {options.map((option) => (
                            <Select.Option key={option.key} value={option.value}>{option.key}</Select.Option>
                        ))}
                    </Select>
                </Modal>
            )}
        </div>
    );
}
